import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import axios from 'axios';
import Loader from '../common/Loader';

const cookies = new Cookies();

class AuthTemp extends Component {
    async componentDidMount() {
        try {
            const params = new URLSearchParams(window.location.search);
            const code = params.get('code');

            if (!code) {
                throw new Error('Authorization code not found');
            }


            const response = await axios.get(
                `${process.env.REACT_APP_MANAGEMENT_CENTER_BACKEND_URL}/getToken`,
                {
                    params: {
                        code
                    }
                }
            );



            await setTimeout(() => { }, 50000);

            const {
                access_token,
                refresh_token,
                id_token,
                fullName,
                email,
            } = response.data;

            const cookieOptions = {
                path: '/',
            };

            cookies.set(
                'access_token',
                access_token,
                cookieOptions
            );

            cookies.set(
                'USERNAME',
                email,
                cookieOptions
            );

            cookies.set(
                'FULLNAME',
                fullName,
                cookieOptions
            );

            cookies.set(
                'refresh_token',
                refresh_token,
                cookieOptions
            );

            if (id_token) {
                cookies.set(
                    'id_token',
                    id_token,
                    cookieOptions
                );
            }

            window.location.replace('/');
        } catch (error) {
            console.error('Authentication failed', error);

            cookies.remove('access_token');
            cookies.remove('refresh_token');
            cookies.remove('id_token');

            window.location.replace('/clearcookie#logout');
        }
    }

    render() {
        return (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{
                    height: '100vh'
                }}
            >
                <Loader />
            </div>
        );
    }
}

export default withRouter(AuthTemp);


// WEBPACK FOOTER //
// ./src/components/pages/auth/AuthTemp.js